import React from 'react';
import { hero } from '../data/siteContent';

const HeroSection: React.FC = () => {
  const [line1, line2] = hero.title.split('\n');

  return (
    <section className="relative overflow-hidden pt-28 sm:pt-36">
      <div className="shell">
        <div className="grid items-start gap-14 lg:grid-cols-12 lg:gap-gutter">
          <div className="animate-slide-up lg:col-span-7">
            <p className="kicker-action">{hero.eyebrow}</p>

            <h1 className="display-xl mt-6 text-[3.25rem] sm:text-[4.5rem] lg:text-[5.25rem]">
              {line1}
              <br />
              <span className="text-primary">{line2}</span>
            </h1>

            <p className="prose-reading mt-8 max-w-reading">{hero.standfirst}</p>

            <div className="mt-10 flex flex-wrap items-center gap-4">
              <a href="#lookup" className="btn-primary">
                {hero.primaryCta}
              </a>
              <a href="#screens" className="btn-ghost">
                {hero.secondaryCta}
              </a>
            </div>

            <p className="kicker mt-8">{hero.meta}</p>
          </div>

          {/* The plate. Image first, annotation pinned beneath it. Capped well
              below the column width — a full-height phone here would swamp the
              headline it is meant to support. */}
          <figure className="animate-fade-in mx-auto w-full max-w-[16rem] sm:max-w-[18rem] lg:col-span-5 lg:ml-auto lg:mr-0 lg:max-w-[17.5rem]">
            <div className="plate relative bg-background p-2">
              <img
                src="/screenshots/iphone/01-learn-mode.png"
                width={1320}
                height={2868}
                alt="Lexeme asking what the Italian word mangiava means, with four possible answers"
                className="block h-auto w-full"
                fetchPriority="high"
                decoding="async"
              />
            </div>
            <figcaption className="mt-4 flex items-baseline gap-3 border-t border-ink/15 pt-3">
              <span className="whitespace-nowrap font-display text-sm text-primary" aria-hidden="true">
                Pl. 01
              </span>
              <span className="prose-note text-[0.875rem]">
                Learn mode, mid-guess. The sentence stays above the question.
              </span>
            </figcaption>
          </figure>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
